import type { RootState } from "@/app/store";

export const selectIsClaimingMysteryBox = (state: RootState) =>
  state.mysteryBox.isClaimingMysteryBox;
